import React, { useState, useEffect } from "react";
import {
  LicenseInfo,
  DataGridPro,
  GridRowModel,
  GridOverlay,
  useGridApiRef,
  GridToolbarFilterButton,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridRowId,
} from "@mui/x-data-grid-pro";
import {
  styled,
  Box,
  Pagination,
  Stack,
  Select,
  MenuItem,
  Typography,
  TextField,
  Autocomplete,
  Button,
  Tooltip,
  TablePagination,
} from "@mui/material";
import {
  ExpandMore,
  ExpandLess,
  UnfoldMore,
  SaveAlt,
} from "@mui/icons-material";
import PropTypes from "prop-types";
import MultiSelect from "../../../components/Common/ElementInForm/MultiSelectWithChip";
import { BtnSearch, BtnCancel, BtnRemove } from "../../../components/Common/Button";
import { FormProvider, useForm } from "react-hook-form";
import ClearIcon from "@mui/icons-material/Clear";
import DateRange from "../../../components/Common/ElementInForm/DateRangeSigleBox";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import useMediaQuery from '@mui/material/useMediaQuery';
import { currentLanguage } from "service/CommonFunction/AxiosConfig";

LicenseInfo.setLicenseKey(
  "5b31a40e910ea0c2a35371ae57c5b5beT1JERVI6MzYzMjEsRVhQSVJZPTE2NzQyOTE1NTAwMDAsS0VZVkVSU0lPTj0x"
);

export interface PaginationInterface {
  nPageIndex: number;
  nPageSize: number;
  arrRows: GridRowModel[];
  nDataLength: number;
  sSortExpression: string;
  sSortDirection: string;
  sID: string;
  IsMinLayout700: boolean;
}

export interface FilterFieldInterface {
  sFieldName: string;
  sLabel?: string;
  sInputMode?:
  | "text"
  | "numeric"
  | "none"
  | "search"
  | "email"
  | "decimal"
  | "tel"
  | "url";
  sTypeFilterMode: "input" | "select" | "multiselect" | "daterange";
  sType?: string;
  lstDataSelect?: OptionSelect[];
}
interface OptionSelect {
  value: any;
  label: any;
  keyId: any;
}
export const initRows: PaginationInterface = {
  nPageIndex: 1,
  nPageSize: 10,
  // rows: [],
  arrRows: [],
  nDataLength: 0,
  sSortExpression: "",
  sSortDirection: "",
  sID: "",
  IsMinLayout700: false,
};

const StyledGridOverlay = styled(GridOverlay)(({ theme }) => ({
  flexDirection: "column",
}));
const GridToolbarClearFilterButton = styled(Button)(({ theme }) => ({
  fontSize: "0.8125rem",
  padding: "4px 5px",
}));

export function DataGridMui(props) {
  const {
    minHeightCustom,
    onCickRow,
    maxRowNoScroll,
    sxCustomHeader,
    sxCustomTable,
    backgroundHeaderCustom,
    lstPageSize,
    Rows,
    Columns,
    isLoading,
    OnLoadData,
    isShowCheckBox,
    filterField,
    onDelete,
    disableColumnMenu,
    isNotShowTotal,
    isNotShowPagination,
    isNotShowPageSize,
    isCustomOnFilter,
    onFilterCustom,
    isRowSelectable,
    isExportExcel,
    onExportExcel,
    HiddenToolHead,
    HandleDataMode,
    getDetailPanelContent,
    getDetailPanelHeight,
    rowReordering,
    onRowOrderChange,
    hideFooter,
    ArrSelect,
    setArrSelect,
    disableColumnReorder,
    initialState
  } = props;
  const apiRef = useGridApiRef();
  let lstPageData = [];
  let lstPage = [];
  const [lstSelectRowId, setLstSelectRowId] = useState([]);
  const [lstDefaultSorting, setDefaultSorting] = useState(null);
  const [selectionModel, setSelectionModel] = React.useState<GridRowId[]>(ArrSelect || []);
  const layout700 = true;
  // const layout700 = useMediaQuery('(min-width:700px)');

  useEffect(() => {
    setSelectionModel(ArrSelect)
  }, [ArrSelect])

  // useEffect(() => {
  //   if(Rows){
  //     Rows.IsMinLayout700 = !layout700;
  //   }
  // }, [layout700])
  const CustomNoRowsOverlay = () => {
    return (
      <StyledGridOverlay>
        <Box>{currentLanguage() == "th" ? "ไม่พบข้อมูล" : "No data"}</Box>
      </StyledGridOverlay>
    );
  };

  if (lstDefaultSorting == null) {
    let defaultData = {
      sSortDirection: Rows.sSortDirection,
      sSortExpression: Rows.sSortExpression
    }
    setDefaultSorting(defaultData)
  }

  const clearFilter = () => {
    let cloneData = {
      nPageSize: Rows.nPageSize,
      nPageIndex: 1,
      sSortExpression: "",
      sSortDirection: "",
      arrRows: [],
    };
    if (isCustomOnFilter) {
      onFilterCustom(cloneData, null);
    } else {
      OnLoadData(cloneData);
    }
  };


  const QuickSearchToolbar = (isFilter: boolean) => {
    return (
      <Stack
        className="head-container"
        sx={{
          px: 0.5,
          pb: 0.5,
          bgcolor: "white",
        }}
        direction="row"
        justifyContent="start"
      >
        <GridToolbarContainer>
          <Tooltip title={"Show columns"}>
            <GridToolbarColumnsButton />
          </Tooltip>
          {isFilter ? (
            <GridToolbarFilterButton disableTouchListener={isLoading} />
          ) : null}
          {filterField &&
            filterField.some(
              (item) =>
                Rows[item.sFieldName] ||
                (Rows[item.sFieldName] == 0 && item.sTypeFilterMode == "select")
            ) ? (
            <Tooltip title={"Clear filters"}>
              <GridToolbarClearFilterButton
                disabled={isLoading}
                onClick={() => clearFilter()}
              >
                <ClearIcon sx={{ marginRight: "0.2em" }} />
                Clear Filter
              </GridToolbarClearFilterButton>
            </Tooltip>
          ) : null}
          {isExportExcel ? (
            <Tooltip title={"Export excel"}>
              <GridToolbarClearFilterButton
                disabled={isLoading}
                onClick={() => onExportExcel()}
              >
                <SaveAlt sx={{ marginRight: "0.2em" }} />
                Export excel
              </GridToolbarClearFilterButton>
            </Tooltip>
          ) : null}
        </GridToolbarContainer>
      </Stack>
    );
  };

  const CustomPagination = () => {
    const maxRowSizePerPage = Rows.nPageIndex * Rows.nPageSize;
    const rowTotalCount = Rows.nDataLength;
    const minRowSizePerPage = Rows.nPageIndex > 1 ? (Rows.nPageIndex - 1) * Rows.nPageSize + 1 : 1;
    const pageCount = Math.ceil(rowTotalCount / Rows.nPageSize);
    const sumMaxRow = rowTotalCount > maxRowSizePerPage ? maxRowSizePerPage : rowTotalCount;
    lstPageData = [];
    lstPage = [];
    for (let i = 0; i < pageCount; i++) {
      lstPageData.push({ label: i + 1, value: i });
      lstPage.push(<MenuItem value={i}>{i + 1}</MenuItem>);
    }

    const handleChangePage = (
      event: React.MouseEvent<HTMLButtonElement> | null,
      newPage: number,
    ) => {
      if (!isLoading) {
        let cloneData = { ...Rows, nPageIndex: newPage, arrRows: [] };
        if (HandleDataMode != "client") {
          OnLoadData(cloneData)
        };
      }
    };

    const handleChangeRowsPerPage = (
      event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
      apiRef.current.setPageSize(parseInt(event.target.value, 10));
    };


    return (rowTotalCount < 1 && !isNotShowTotal) || isNotShowPagination ? (
      <Box sx={{ display: "block", width: "100%" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignContent="center"
          sx={{ px: 2 }}
        >
          {lstSelectRowId.length > 0 && onDelete != undefined ? (
            <BtnRemove
              isCircleWithOutText
              onClick={() => onDelete(lstSelectRowId)}
            />
          ) : (
            <Box></Box>
          )}
          <Stack justifyContent="center">
            <Typography>Total : {rowTotalCount}</Typography>
          </Stack>
        </Stack>
      </Box>
    ) : (
      isNotShowPageSize ? (
        <Stack
          direction="row"
          sx={{ px: 2, minWidth: "550px" }}
          justifyContent="space-between"
          alignItems="center"
          flex={1}
          spacing={1}
        >
          {lstSelectRowId.length > 0 && onDelete != undefined ? (
            <BtnRemove
              isCircleWithOutText
              txt={"ลบ"}
              onClick={() => onDelete(lstSelectRowId)}
            />
          ) : (
            <Box></Box>
          )}
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography>{`${minRowSizePerPage > sumMaxRow ? sumMaxRow : minRowSizePerPage} - ${sumMaxRow} of ${rowTotalCount}`}</Typography>
            {layout700 ?
              <>
                <Pagination
                  color="primary"
                  count={pageCount}
                  page={Rows.nPageIndex}
                  siblingCount={0}
                  variant="outlined"
                  shape="rounded"
                  onChange={(event, value) => {
                    if (!isLoading) {
                      let cloneData = { ...Rows, nPageIndex: value, arrRows: [] };
                      // OnLoadData(cloneData);
                      if (HandleDataMode != "client") OnLoadData(cloneData);
                    }
                  }}
                />
              </>
              :
              <>
                <TablePagination
                  component="div"
                  count={rowTotalCount}
                  page={Rows.nPageIndex}
                  onPageChange={handleChangePage}
                  rowsPerPage={Rows.nPageSize}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage={""}
                  labelDisplayedRows={({ from, to, count }) => { return `Total : ${count !== -1 ? count : `0`}`; }}
                />
              </>
            }
          </Stack>
        </Stack>
      ) :
        !isNotShowPagination &&
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          flex={1}
          spacing={1}
        >
          {lstSelectRowId.length > 0 && onDelete != undefined ? (
            <BtnRemove
              isCircleWithOutText
              txt={"ลบ"}
              onClick={() => onDelete(lstSelectRowId)}
            />
          ) : (
            <Box></Box>
          )}
          {layout700 ?
            <>
              <Stack direction="row" alignItems="center">
                <Typography>{`${minRowSizePerPage > sumMaxRow ? sumMaxRow : minRowSizePerPage} - ${sumMaxRow} of ${rowTotalCount}`}</Typography>
                <Pagination
                  color="primary"
                  count={pageCount}
                  page={Rows.nPageIndex}
                  variant="outlined"
                  siblingCount={0}
                  shape="rounded"
                  onChange={(event, value) => {
                    if (!isLoading) {
                      let cloneData = { ...Rows, nPageIndex: value, arrRows: [] };
                      // OnLoadData(cloneData);
                      if (HandleDataMode != "client") OnLoadData(cloneData);
                    }
                  }}
                />
                <Select
                  label=""
                  size="small"
                  disabled={isLoading}
                  autoWidth
                  sx={{
                    height: 30,
                    ".MuiOutlinedInput-notchedOutline > legend": {
                      width: 0,
                    },
                  }}
                  value={lstPageSize.indexOf(Rows.nPageSize)}
                  onChange={(e) => {
                    apiRef.current.setPageSize(lstPageSize[e.target.value]);
                  }}
                >
                  {lstPageSize.map((item, index) => (
                    <MenuItem key={`selPageSize_${index}`} value={index}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </Stack>
            </>
            :
            <>
              <TablePagination
                component="div"
                count={rowTotalCount}
                page={Rows.nPageIndex}
                onPageChange={handleChangePage}
                rowsPerPage={Rows.nPageSize}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={""}
                labelDisplayedRows={({ from, to, count }) => { return `Total : ${count !== -1 ? count : `0`}`; }}
              />
            </>
          }

        </Stack>
    );
  };

  const CustomFilterPanel = () => {
    const form = useForm();
    const [innerStateRow, setInnerState] = useState(Rows);
    const _onSubmit = (e) => {
      let cloneData = {
        nPageSize: innerStateRow.nPageSize,
        nPageIndex: 1,
        sSortExpression: "",
        sSortDirection: "",
        rows: [],
      };
      filterField.forEach((item) => {
        if (
          (e[`inp_filter_${item.sFieldName}`] != undefined &&
            e[`inp_filter_${item.sFieldName}`] != "") ||
          (item.sTypeFilterMode == "select" &&
            e[`inp_filter_${item.sFieldName}`] == 0)
        ) {
          if (
            item.sTypeFilterMode == "daterange" &&
            e[`inp_filter_${item.sFieldName}`][0] != null &&
            e[`inp_filter_${item.sFieldName}`][1] != null
          ) {
            cloneData[`lst${item.sFieldName}`] = [
              e[`inp_filter_${item.sFieldName}`][0].toDate().getTime(),
              e[`inp_filter_${item.sFieldName}`][1].toDate().getTime(),
            ];
          }
          cloneData[item.sFieldName] = e[`inp_filter_${item.sFieldName}`];
        }
      });
      if (isCustomOnFilter) {
        onFilterCustom(cloneData, e);
      } else {
        OnLoadData(cloneData);
      }
    };

    return (
      <div style={{ maxHeight: 200, overflow: "auto", width: "100%" }}>
        <Stack style={{ padding: "10px" }} direction="column" spacing={1}>
          <FormProvider {...form}>
            {filterField.map((item) => {
              const labelFilter = item.sLabel
                ? item.sLabel
                : Columns.find((f) => f.field == item.sFieldName).headerName;
              form.setValue(
                `inp_filter_${item.sFieldName}`,
                innerStateRow[item.sFieldName]
                  ? innerStateRow[item.sFieldName]
                  : null
              );
              switch (item.sTypeFilterMode) {
                case "input": {
                  return (
                    <TextField
                      key={`tf_${item.sFieldName}`}
                      type={item.sType || "text"}
                      inputProps={{
                        inputMode:
                          item.sInputMode != null ? item.sInputMode : "text",
                      }}
                      size="small"
                      autoComplete="off"
                      label={labelFilter}
                      name={`inp_filter_${item.sFieldName}`}
                      {...form.register(`inp_filter_${item.sFieldName}`)}
                    />
                  );
                }
                case "select": {
                  return (
                    <Autocomplete
                      key={`ac_${item.sFieldName}`}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.value}>
                            {option.label}
                          </li>
                        );
                      }}
                      defaultValue={
                        innerStateRow[item.sFieldName] != undefined
                          ? {
                            label: item.lstDataSelect.find(
                              (f) => f.value == innerStateRow[item.sFieldName]
                            ).label,
                            value: innerStateRow[item.sFieldName],
                          }
                          : null
                      }
                      size="small"
                      name={`inp_filter_${item.sFieldName}`}
                      {...form.register(`inp_filter_${item.sFieldName}`)}
                      onChange={(e, v) => {
                        form.setValue(
                          `inp_filter_${item.sFieldName}`,
                          v?.value ?? null
                        );
                        innerStateRow[item.sFieldName] = v?.value ?? null;
                        setInnerState({ ...innerStateRow });
                      }}
                      options={item.lstDataSelect}
                      getOptionLabel={(itemOption: any) => {
                        return `${itemOption.label}`;
                      }}
                      renderInput={(params) => (
                        <TextField label={labelFilter} {...params} />
                      )}
                    />
                  );
                }
                case "multiselect": {
                  return (
                    <MultiSelect
                      key={`ms_${item.sFieldName}`}
                      valueData={
                        innerStateRow[item.sFieldName]
                          ? innerStateRow[item.sFieldName]
                          : []
                      }
                      fnOnChange={(s) => {
                        innerStateRow[item.sFieldName] = s;
                        setInnerState({ ...innerStateRow });
                      }}
                      onDeleteChip={(e) => {
                        innerStateRow[item.sFieldName] = innerStateRow[
                          item.sFieldName
                        ].filter((f) => f != e);
                        setInnerState({ ...innerStateRow });
                      }}
                      small
                      name={`inp_filter_${item.sFieldName}`}
                      options={item.lstDataSelect}
                      label={labelFilter}
                    />
                  );
                }
                case "daterange": {
                  return (
                    <DateRange
                      key={`dr_${item.sFieldName}`}
                      value={
                        innerStateRow[item.sFieldName]
                          ? innerStateRow[item.sFieldName]
                          : [null, null]
                      }
                      small
                      name={`inp_filter_${item.sFieldName}`}
                      label={labelFilter}
                    />
                  );
                }
              }
            })}
            <BtnSearch txt={"Search"} onClick={form.handleSubmit(_onSubmit)} />
          </FormProvider>
        </Stack>
      </div>
    );
  };

  return (
    <>
      <DataGridPro
        density="compact"
        localeText={{
          columnsPanelHideAllButton: "ซ่อนทั้งหมด",
          columnsPanelShowAllButton: "แสดงทั้งหมด",
          columnsPanelTextFieldLabel: "ค้นหาคอลัมน์",
          columnsPanelTextFieldPlaceholder: "คอลัมน์",
          toolbarColumns: "คอลัมน์",
          checkboxSelectionHeaderName: "เลือก",
        }}
        rows={isLoading ? [] : Rows.arrRows}
        getRowId={(item) => item.sID}
        columns={Columns}
        pagination
        disableSelectionOnClick
        apiRef={apiRef}
        checkboxSelection={isShowCheckBox}
        loading={isLoading}
        initialState={initialState}
        autoHeight={true}
        disableColumnReorder={disableColumnReorder}
        selectionModel={selectionModel}
        onSelectionModelChange={(itm) => {
          setLstSelectRowId(itm);
          setArrSelect && setArrSelect(itm);
          setSelectionModel(itm);
        }}
        filterMode={HandleDataMode}
        paginationMode={HandleDataMode}
        onRowClick={(e) => onCickRow(e)}
        sortingMode={HandleDataMode}
        pageSize={Rows.nPageSize}
        rowCount={Rows.nDataLength}
        page={Rows.nPageIndex}
        disableMultipleColumnsSorting
        hideFooter={hideFooter ? true : false}
        onSortModelChange={(model, detail) => {
          if (model.length > 0) {
            let cloneData = {
              ...Rows,
              sSortExpression: model[0].field,
              sSortDirection: model[0].sort,
              arrRows: [],
            };
            OnLoadData(cloneData);
          } else {
            let cloneData = {
              ...Rows,
              sSortExpression: lstDefaultSorting.sSortExpression || "",
              sSortDirection: lstDefaultSorting.sSortDirection || "",
              arrRows: [],
            };
            OnLoadData(cloneData);
          }
        }}
        hideFooterSelectedRowCount

        components={{
          DetailPanelExpandIcon: () => <ExpandMoreIcon />,
          DetailPanelCollapseIcon: () => <ExpandLessIcon />,
          FilterPanel:
            !HiddenToolHead && filterField.length > 0
              ? CustomFilterPanel
              : () => null,
          Toolbar: () =>
            !HiddenToolHead ? QuickSearchToolbar(filterField.length > 0) : null,
          Pagination: CustomPagination,
          NoRowsOverlay: CustomNoRowsOverlay,
          ColumnSortedDescendingIcon: () => <ExpandMore style={{ fontSize: "1em", color: '#ffffff' }} />,
          ColumnSortedAscendingIcon: () => <ExpandLess style={{ fontSize: "1em", color: '#ffffff' }} />,
          ColumnUnsortedIcon: () => <UnfoldMore style={{ fontSize: "1em", color: '#ffffff' }} />,
          // RowReorderIcon: () => <SwapVertIcon />, //Icon Drag Drop
        }}
        disableColumnMenu={disableColumnMenu}
        onPageSizeChange={(pageSize) => {
          let cloneData = {
            ...Rows,
            nPageSize: pageSize,
            nPageIndex: 1,
            rows: [],
          };
          OnLoadData(cloneData);
        }}
        isRowSelectable={isRowSelectable}
        rowThreshold={0}

        getDetailPanelHeight={getDetailPanelHeight}
        getDetailPanelContent={getDetailPanelContent}
        disableVirtualization={true}
        rowReordering={rowReordering}
        onRowOrderChange={onRowOrderChange}
        getRowHeight={() => 'auto'}
        sx={{
          minHeight: Rows.arrRows.length < maxRowNoScroll ? 0 : minHeightCustom,
          " .MuiDataGrid-main": {
            overflowX: "hidden",
            overflowY: "auto",
            ".MuiDataGrid-columnHeaders > .MuiDataGrid-columnHeadersInner > .MuiDataGrid-columnHeader--sortable > .MuiDataGrid-columnHeaderDraggableContainer > div ":
            {
              ".MuiDataGrid-iconButtonContainer": {
                visibility: "initial",
                width: "auto",
              },

            }
          },
          ".MuiDataGrid-iconButtonContainer": {
            visibility: "visible",
            width: "auto",
          },
          " .MuiDataGrid-main>div:first-of-type": {
            height: Rows.arrRows.length < 1 ? "100% !important" : "auto",
            top: Rows.arrRows.length < 1 ? "0 !important" : "39",
          },
          ".MuiDataGrid-cellContent": {
            whiteSpace: "nowrap",
          },
          ".MuiDataGrid-renderingZone": {
            maxHeight: 'none !important',
          },
          ".MuiDataGrid-row": {
            "&:nth-of-type(even)": {
              background: "#f0f0f0"
            },
            "&:hover": {
              background: "#fcf9f9"
            },
            maxHeight: 'none !important',
          },
          ".MuiDataGrid-pinnedColumnHeaders": {
            backgroundColor:backgroundHeaderCustom
          },
          " .MuiDataGrid-columnHeaders": {
            background: backgroundHeaderCustom,
            // maxHeight:'none !important',
            ...sxCustomHeader,
            ".MuiCheckbox-root": {
              ...sxCustomHeader,
            }
          },
          " .MuiDataGrid-cell": {
            color: "#333333",
            lineHeight: 'unset !important',
            // maxHeight: 'none !important',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            // backgroundColor: "white",
            py: '8px',
          },
          " .MuiDataGrid-footerContainer": {
            // backgroundColor: "white",
            overflowX: "auto",
            overflowY: "hidden",
            maxWidth: "100vw",
            justifyContent: 'space-around'
          },
          ".MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
            borderRight: `1px solid rgba(224, 224, 224, 1)`,
          },
          " .MuiDataGrid-columnSeparator": {
            opacity: "0!important",
          },
          " .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
            borderBottom: `1px solid rgba(224, 224, 224, 1)`,
          },
          " .row-odd": {
            bgcolor: "#F1F1F1",
          },
          ".MuiDataGrid-row--lastVisible, .MuiDataGrid-cell": {
            // change on 17/06/2022
            // borderColor:"#e0e0e0 ! important"
            borderColor: "#fcf8f8 ! important",
          },
          ".MuiTypography-root": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          },
          ".MuiDataGrid-cell:focus, .MuiDataGrid-columnHeader:focus": {
            outline: "none"
          },
          ".css-hepa4m-MuiSvgIcon-root": {
            ...sxCustomHeader
          },
          ...sxCustomTable,
        }}
      />
    </>
  );
}
DataGridMui.defaultProps = {
  Rows: initRows,
  isLoading: false,
  isShowCheckBox: false,
  filterField: [],
  onDelete: undefined,
  disableColumnMenu: true,
  lstPageSize: [10, 25, 50, 100],
  // backgroundHeaderCustom: "#eeeeee",
  backgroundHeaderCustom: "#004290",
  maxRowNoScroll: 10,
  // minHeightCustom: 500,
  onCickRow: () => { },
  isCustomOnFilter: false,
  onFilterCustom: () => { },
  HiddenToolHead: false,
  HandleDataMode: "server",
  sxCustomHeader: { color: '#ffffff' },
  disableColumnReorder: true,
};

DataGridMui.propTypes = {
  Rows: PropTypes.object,
  HiddenToolHead: PropTypes.bool,
  Columns: PropTypes.array.isRequired,
  OnLoadData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isShowCheckBox: PropTypes.bool,
  disableColumnMenu: PropTypes.bool,
  filterField: PropTypes.array,
  OnDelete: PropTypes.func,
  isNotShowTotal: PropTypes.bool,
  isNotShowPagination: PropTypes.bool,
  isNotShowPageSize: PropTypes.bool,
  lstPageSize: PropTypes.array,
  backgroundHeaderCustom: PropTypes.string,
  sxCustomHeader: PropTypes.any,
  sxCustomTable: PropTypes.any,
  maxRowNoScroll: PropTypes.number,
  minHeightCustom: PropTypes.number,
  onCickRow: PropTypes.func,
  isCustomOnFilter: PropTypes.bool,
  onFilterCustom: PropTypes.func,
  isRowSelectable: PropTypes.func,
  onExportExcel: PropTypes.func,
  isExportExcel: PropTypes.bool,
  HandleDataMode: PropTypes.oneOf(["server", "client"]),
  ContentExpand: PropTypes.any,
  onExpand: PropTypes.func,
  nExpandRowLength: PropTypes.number,
  id: PropTypes.string,
  getDetailPanelContent: PropTypes.any,
  getDetailPanelHeight: PropTypes.any,
  rowReordering: PropTypes.bool,
  onRowOrderChange: PropTypes.func,
  hideFooter: PropTypes.bool,
  ArrSelect: PropTypes.array,  //ส่ง Arr ID ส่ง Select
  setArrSelect: PropTypes.any,  //ส่ง set ของ State
  initialState: PropTypes.any, 
  disableColumnReorder: PropTypes.bool
};